var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBikeWhite = function SvgBikeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.435,
    height: 38.5
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bike-white_svg__a",
    width: 58.435,
    height: 38.5,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bike-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M17.201 5.36a.61.61 0 0 0 .612.612h2.607l2.141 6.154-3.411 5.786a8.345 8.345 0 0 0-8.033 14.614h-5.75a.612.612 0 1 0 0 1.223h47.711a.612.612 0 1 0 0-1.223h-5.756a8.345 8.345 0 0 0-7.872-14.69L36.783 6.847h5.046a.6.6 0 0 0 .184.028 2.353 2.353 0 0 1 0 4.706.612.612 0 0 0 0 1.223 3.577 3.577 0 0 0 .176-7.149.6.6 0 0 0-.2-.033h-5.984a.612.612 0 0 0-.594.756l1.261 5.2h-13L21.72 5.969h2.4a.612.612 0 0 0 0-1.223h-6.3a.61.61 0 0 0-.612.612Zm5.888 8.28 3.7 10.64a3.37 3.37 0 0 0-1.569 1.91l-1.448-.21c.014-.2.03-.39.03-.588a8.35 8.35 0 0 0-3.6-6.862Zm7.461 13.574a2.131 2.131 0 1 1-2.131-2.131 2.133 2.133 0 0 1 2.131 2.131Zm-7.99-1.409-6.123-.887 3.143-5.328a7.12 7.12 0 0 1 3 5.8c0 .139-.013.275-.021.412Zm-14.246-.412a7.117 7.117 0 0 1 10.213-6.425l-3.6 6.106v.006a1 1 0 0 0-.028.081.6.6 0 0 0-.05.142.6.6 0 0 0 .013.238.6.6 0 0 0 .083.173c.008.012.01.027.018.038a.6.6 0 0 0 .179.16.6.6 0 0 0 .2.07c.008 0 .015.007.023.008l7.028 1.018A7.13 7.13 0 0 1 8.32 25.384Zm41.811 0a7.134 7.134 0 1 1-11.271-5.8l3.863 6.126a.612.612 0 0 0 1.033-.652l-3.844-6.1a7.117 7.117 0 0 1 10.217 6.423Zm-15.49 0a8.35 8.35 0 0 0 4.026 7.134H19.778a8.37 8.37 0 0 0 3.826-5.334l1.468.213a3.352 3.352 0 1 0 5.383-2.846l6.946-9.965.937 3.864a8.36 8.36 0 0 0-3.7 6.938Zm2.334-12.588.048.2-7.662 10.991a3.2 3.2 0 0 0-1.4-.1l-3.859-11.09z",
    "data-name": "Path 63"
  }))));
};
export default SvgBikeWhite;